/**
 * Clave de un solo envío (idempotencia).
 *
 * BUSINESS: las bóvedas y los gastos del turno se guardan con esta clave, así que un envío
 * repetido —por ejemplo un reintento después de un timeout del que no sabemos si llegó—
 * devuelve el movimiento ya creado en lugar de registrar el dinero dos veces.
 *
 * NOTE: es una clave por **envío**, no por movimiento: se genera al empezar el envío y se
 * reutiliza en el reintento (se descarta cuando el movimiento se confirma).
 */
export function nuevaClaveDeEnvio(): string {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return crypto.randomUUID();
  }

  return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
}
